import CustomerImport from '@/views/MarketingCenter/CustomerImport/CustomerImport.vue';
import flagKeys from '@/constants/flagKeys';

import { Route } from '../route.model';
import { IBusinessType } from '@/models/business';
import { customerImportValidator } from '../validators/navbar';

const customerImport = new Route(
  '/customer-import',
  'customer-import',
  CustomerImport,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.customerImport,
    validator: () => customerImportValidator(),
    navbar: {
      name: 'Invite Customers',
      icon: 'invite-customers',
      description:
        'Easily invite your email database to join your Loyalty Rewards Program.'
    },
    pageView: {
      eventLabel: 'Invite Customers'
    },
    feature: {
      type: IBusinessType.ONLINE
    },
    needProviderConnected: true
  }
);

export { customerImport };
export default customerImport;
